export function naturalSubcategoryLinks(title: string, prefix?: string) {
  prefix = prefix ?? "/subscriber/reports/";
  switch (title) {
    case "Earthquakes":
      return prefix + "earthquakes";
    case "Tornadoes":
      return prefix + "tornadoes";
    case "Riverine Floods":
      return prefix + "riverine-flooding";
    case "Wildfires":
      return prefix + "wildfires";
    case "Winter Weather":
      return prefix + "winter-weather";
    case "Hail":
      return prefix + "hail";
    case "Hurricanes":
      return prefix + "hurricanes";
    case "Drought":
      return prefix + "droughts";
    case "Coastal Floods":
      return prefix + "coastal-flooding";
    default:
      prefix;
  }
}
